// extracted by mini-css-extract-plugin
export default {"thumbnail":"thumbnail_thumbnail__M6jFb"};